/**
 * Resuelve el tab inicial de internas con tabs.
 * Prioriza `location.state.initialTab` (history.push) y, si no hay state,
 * lee `?initialTab` de la URL (p. ej. `window.location.href` o `window.open`).
 */
export const parseInitialTabFromLocation = (
  search: string,
  stateInitialTab?: number,
  defaultTab = 0
): number => {
  if (stateInitialTab != null && Number.isFinite(stateInitialTab)) {
    return stateInitialTab;
  }

  const queryTab = new URLSearchParams(search).get('initialTab');
  if (queryTab != null) {
    const parsed = Number(queryTab);
    if (Number.isFinite(parsed)) return parsed;
  }

  return defaultTab;
};
